import { useState, useEffect, useCallback } from "react";
import { ydoc } from "../collab/yjsDoc";
import type { Annotation3D } from "./annotation3DTypes";
import { annotationId } from "./annotation3DTypes";

function yAnnotations() {
  return ydoc.getArray<Annotation3D>("annotations3d");
}

export function useAnnotation3DStore() {
  const [annotations, setAnnotations] = useState<Annotation3D[]>([]);

  useEffect(() => {
    const arr = yAnnotations();
    const sync = () => setAnnotations(arr.toArray());
    sync();
    arr.observe(sync);
    return () => arr.unobserve(sync);
  }, []);

  const addAnnotation = useCallback((
    position: [number, number, number],
    text: string,
    author: string,
    featureId?: string,
    kind: Annotation3D["kind"] = "comment",
  ) => {
    const ann: Annotation3D = {
      id: annotationId(),
      kind,
      position,
      featureId,
      text,
      author,
      createdAt: Date.now(),
      resolved: false,
    };
    ydoc.transact(() => { yAnnotations().push([ann]); });
    return ann;
  }, []);

  const resolveAnnotation = useCallback((id: string) => {
    const arr = yAnnotations();
    const idx = arr.toArray().findIndex((a) => a.id === id);
    if (idx < 0) return;
    const updated = { ...arr.get(idx), resolved: true };
    ydoc.transact(() => {
      arr.delete(idx, 1);
      arr.insert(idx, [updated]);
    });
  }, []);

  const deleteAnnotation = useCallback((id: string) => {
    const arr = yAnnotations();
    const idx = arr.toArray().findIndex((a) => a.id === id);
    if (idx >= 0) {
      ydoc.transact(() => { arr.delete(idx, 1); });
    }
  }, []);

  return { annotations, addAnnotation, resolveAnnotation, deleteAnnotation };
}
